import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import editIconActive from '../../../images/insight360/edit-icon_active.png';
import filterIconActive from '../../../images/insight360/filter-icon_active.png';
import infoIconWhite from '../../../images/insight360/info-icon_white.png';
import clearFilterIcon from '../../../images/insight360/clear-field-icon_white.png';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  SAMPLE_INFO_MSG,
} from '../../../messages/messages';
import {
  WEIGHTED_LABEL,
  REACH_LABEL,
  SELECTED_FILTER_LABEL,
  LENGHTOF_PDF_LABEL,
  SAMPLE_LABEL,
  REMOVE_PERSONA_CLICK,
  CHANGE_FILTER_FROM_HEADER,
} from '../../../constants';
import DemographicFilter from './DemographicFilter';
import Modal from '../../common/Modal/Modal';
import GenericButton from '../../common/GenericButton';
import { numberWithCommas, nthOccurrence } from '../../../util/CommonUtils';
import InlineEdit from '../../common/InlineEdit/InlineEdit';

const modalWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class DemographicsSinglePersonaHeaderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteractive: false,
      selectedFilterOption: undefined,
      selectedFilterOptionToolTip: undefined,
      showWarning: false,
      insight360PersonaFixedHeaderChoice: false,
      weight: this.props.weight !== undefined ? this.props.weight : 0,
      pct: this.props.pct !== undefined ? this.props.pct : 0,
      sample: this.props.sample !== undefined ? this.props.sample : 0,
    };
  }

  componentDidMount() {
    this.didMountMethod();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.personaFilter !== undefined &&
      nextProps.index !== undefined
    ) {
      const filter = nextProps.personaFilter[nextProps.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
      const emptyIndex = nextProps.personaFilter.filterIndex;
      if (nextProps.personaFilter[emptyIndex] === '') {
        this.setState({ selectedFilterOption: undefined });
        this.setState({ selectedFilterOptionToolTip: undefined });
      }
    }

    if (
      nextProps.insight360PersonaFilter !== undefined &&
      nextProps.index !== undefined
    ) {
      const filter = nextProps.insight360PersonaFilter[nextProps.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
    }

    if (
      nextProps.insight360PersonaFixedHeaderChoice !== undefined &&
      this.props.insight360PersonaFixedHeaderChoice !==
        nextProps.insight360PersonaFixedHeaderChoice
    ) {
      this.setState({
        insight360PersonaFixedHeaderChoice:
          nextProps.insight360PersonaFixedHeaderChoice,
      });
    }

    if (
      nextProps.weight !== undefined &&
      this.props.weight !== nextProps.weight
    ) {
      this.setState({ weight: nextProps.weight });
    }

    if (
      nextProps.sample !== undefined &&
      this.props.sample !== nextProps.sample
    ) {
      this.setState({ sample: nextProps.sample });
    }

    if (nextProps.pct !== undefined && this.props.pct !== nextProps.pct) {
      this.setState({ pct: nextProps.pct });
    }
  }

  getIndexOfPdfLabel = () => {
    let lenghtOfPdfLabel = LENGHTOF_PDF_LABEL;
    const nthOccurrenceIndex = nthOccurrence(this.props.label, ')', 2);
    if (
      nthOccurrenceIndex < lenghtOfPdfLabel &&
      nthOccurrenceIndex !== -1 &&
      nthOccurrenceIndex !== 'undefined'
    ) {
      lenghtOfPdfLabel = nthOccurrenceIndex + 1;
    }
    return lenghtOfPdfLabel;
  };

  didMountMethod = () => {
    if (
      this.props.insight360PersonaFilter !== undefined &&
      this.props.index !== undefined
    ) {
      const filter = this.props.insight360PersonaFilter[this.props.index];
      const label = this.findFilterLabel([filter]);
      if (label !== undefined) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      }
    }
  }

  handleFilterClick = () => {
    this.setState({ filteractive: !this.state.filteractive });
  };

  handleRemoveDemographicClick = () => {
    this.modalWarining.show();
    // this.props.removeDemographic(this.props.index);
  };

  handleClearFilterClick = () => {
    this.setState({ selectedFilterOption: undefined });
    this.setState({ selectedFilterOptionToolTip: undefined });
    this.props.filterExpressionChanged([''], this.props.index);
  };

  handleFilterExpressionChanged = filter => {
    if (
      (filter.length > 0 && this.state.selectedFilterOption === undefined) ||
      (filter.length > 0 &&
        filter[0] !== this.state.selectedFilterOption.keyword)
    ) {
      this.props.trackerFn({ action: CHANGE_FILTER_FROM_HEADER });
      this.props.filterExpressionChanged(filter, this.props.index);
      this.handleFilterClick();
      // find the filter label and store it in state
      const label = this.findFilterLabel(filter);
      if (
        label !== undefined &&
        label.title !== undefined &&
        label.title.length > 0
      ) {
        this.setState({ selectedFilterOption: label });
        this.setState({ selectedFilterOptionToolTip: label });
      } else {
        this.setState({ selectedFilterOption: undefined });
        this.setState({ selectedFilterOptionToolTip: undefined });
      }
    } else {
      this.handleFilterClick();
    }
  };

  findFilterLabel = filter => {
    const y = this.props.filterOptions.data;
    const z = _.flatMap(y);
    return _.find(z, { keyword: filter[0] });
  };

  render() {
    const filter = this.props.personaFilter[this.props.index];
    const label = this.findFilterLabel([filter]);
    let selectedFilter;
    const filterDisplay =
      (this.state.selectedFilterOption !== undefined &&
        this.state.selectedFilterOption.title !== undefined &&
        this.state.selectedFilterOption.title.length > 0) ||
      (selectedFilter !== undefined &&
        selectedFilter.title !== undefined &&
        selectedFilter.title.length > 0);
    if (label !== undefined) {
      selectedFilter = label;
    }
    return (
      <div className="row fullwidth">
        <Modal
          title=""
          ref={node => (this.modalWarining = node)}
          dialogStyles={modalWariningStyle}
        >
          <div className="text-center">
            <p>This is going to delete this Selection</p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => {
                this.props.trackerFn({ action: REMOVE_PERSONA_CLICK });
                this.props.removeDemographic(this.props.index);
                this.modalWarining.hide();
              }}
            />
          </div>
        </Modal>
        <div>
          {!_.isEmpty(this.props.expression) && (
            <div>
              <div className="row fullwidth demographic-header-border demographic-detail-columns relative-position">
                <div className="large-6 medium-6 small-6 columns">
                  <div className="demographic-float persona-info-container-single">
                    <div className="">
                      <div className=" inlineEditFlag persona-info xtra-padding">
                        <InlineEdit
                          textVal={this.props.label}
                          editBlockWidth="100%"
                          icon={editIconActive}
                          updateFn={this.props.personaHeaderLabelUpdate}
                          validateFn={this.props.personaHeaderLabelValidate}
                          index={this.props.index}
                        />

                        <span style={{ position: 'absolute' }}>
                          <img
                            className="i360_header_icons_img"
                            src={filterIconActive}
                            alt="filter"
                            onClick={() => this.handleFilterClick()}
                          />
                          {this.props.filterOptions !== undefined && (
                            <DemographicFilter
                              filterOptions={this.props.filterOptions}
                              filterExpressionChanged={
                                this.handleFilterExpressionChanged
                              }
                              index={this.props.index}
                              filterCssClass={
                                this.state.filteractive
                                  ? `${(this.state.filteractive && this.state.insight360PersonaFixedHeaderChoice) === true ? 'fixed-filter-active' : 'filter-active'}`
                                  : 'filter-hidden'
                              }
                              personaFilter={this.props.personaFilter}
                            />
                          )}
                        </span>
                      </div>
                      <div className="persona-info double-info">
                        <span className="pdfSinglePersonaHeaderLabelFlag LabelBlock">
                          {this.props.label.substring(
                            0,
                            this.getIndexOfPdfLabel(),
                          )}
                        </span>
                      </div>

                      <div>
                        {filterDisplay ? (
                          <span className="persona-filter-display pdf-single-persona-filter-display">
                            <strong id="singleFilterLabelFlag">{`${SELECTED_FILTER_LABEL}: `}</strong>
                            <span
                              data-tooltip
                              aria-haspopup="true"
                              title={
                                this.state.selectedFilterOption !== undefined &&
                                this.state.selectedFilterOption.title !==
                                  undefined &&
                                this.state.selectedFilterOption.title.length > 0
                                  ? this.state.selectedFilterOptionToolTip.title
                                  : selectedFilter.title
                              }
                            >
                              {this.state.selectedFilterOption !== undefined &&
                              this.state.selectedFilterOption.title !==
                                undefined &&
                              this.state.selectedFilterOption.title.length > 0
                                ? this.state.selectedFilterOption.title
                                : selectedFilter.title}
                            </span>
                            <img
                              className="i360_header_icons_img"
                              src={clearFilterIcon}
                              alt="Remove"
                              onClick={() => this.handleClearFilterClick()}
                            />
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-2 medium-2 small-2 columns text-align-center">
                  <div className="demographic-float-none">
                    <div className="div-overflow">
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-info'
                            : 'weight-reach-info-report'
                        }
                      >
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-data'
                            : 'weight-reach-data-report'
                        }
                      >
                        {numberWithCommas(Math.round(this.state.sample))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-2 medium-2 small-2 columns">
                  <div className="demographic-float">
                    <div className="div-overflow">
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-info'
                            : 'weight-reach-info-report'
                        }
                      >
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-data'
                            : 'weight-reach-data-report'
                        }
                      >
                        {numberWithCommas(Math.round(this.state.weight))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-2 medium-2 small-2 columns">
                  <div className="demographic-float">
                    <div className="div-overflow">
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-info'
                            : 'weight-reach-info-report'
                        }
                      >
                        {REACH_LABEL}{' '}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div
                        className={
                          this.props.isReports === false
                            ? 'weight-reach-data'
                            : 'weight-reach-data-report'
                        }
                      >
                        {Math.round(this.state.pct * 10) / 10}%
                      </div>
                    </div>
                  </div>
                  <div className="demographic-float-right">
                    <img
                      className="i360_header_icons_img size-lg"
                      src={clearFilterIcon}
                      alt="Remove"
                      onClick={() => {
                        this.handleRemoveDemographicClick();
                      }}
                    />
                    {/*
                        <div className="weight-reach-info">
                          TREND
                        </div>
                        */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  /* getImageIcon(imageKey) {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    } else {
      // code to return default image
    }
  } */
}

DemographicsSinglePersonaHeaderInfo.propTypes = {
  filterExpressionChanged: PropTypes.func,
  index: PropTypes.number,
  removeDemographic: PropTypes.func,
  personaFilter: PropTypes.arrayOf(PropTypes.string),
  insight360PersonaFilter: PropTypes.arrayOf(PropTypes.string),
  expression: PropTypes.string,
  label: PropTypes.string,
  pct: PropTypes.number,
  weight: PropTypes.number,
  sample: PropTypes.number,
  isReports: PropTypes.bool,
  insight360PersonaFixedHeaderChoice: PropTypes.bool,
  trackerFn: PropTypes.func,
};

// function mapDispatchToProps() {
//   return {
//     // insight360Actions: bindActionCreators(insight360Actions, dispatch),
//   };
// }

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    insight360PersonaFilter: state.insight360.insight360PersonaFilter,
    insight360PersonaFixedHeaderChoice:
      state.insight360.insight360PersonaFixedHeaderChoice,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(DemographicsSinglePersonaHeaderInfo);
